import useGetMyRegionPreferences from '@/api/queries/me/useGetMyRegionPreferences';
import { Alert, AnchorButton, Badge, Card, Divider } from '@payaca/ambrosia';
import CurrencyValue from '@payaca/components/currencyValue/CurrencyValue';

import { useJobContent, useProposal } from '@payaca/store/hooks/appState';
import { Job } from '@payaca/types/jobTypesV2';
import { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { InvoiceCard } from './components/InvoiceCard';

const ProtoInvoiceCard: FC<{
  protoInvoiceId: Job['id'];
}> = ({ protoInvoiceId }) => {
  const protoInvoice = useProposal(protoInvoiceId);

  const jobContent = useJobContent(protoInvoice?.jobContentId);

  const issue = useMemo(() => {
    if (protoInvoice?.bouncedAt) {
      return 'E-mail has bounced';
    }
  }, [protoInvoice]);

  const { data: accountRegionPreferences } = useGetMyRegionPreferences();

  if (!protoInvoice || !jobContent || !accountRegionPreferences) return null;

  const card = (
    <InvoiceCard>
      <InvoiceCard.Grid>
        <InvoiceCard.Grid.Element>
          <h3>
            Invoice{' '}
            {protoInvoice.customReference
              ? `#${protoInvoice.customReference}`
              : ``}
          </h3>
        </InvoiceCard.Grid.Element>
        <InvoiceCard.Grid.Element title={'Total amount:'}>
          <p>
            <CurrencyValue
              currency={accountRegionPreferences.currency}
              value={jobContent.total}
            />
          </p>
        </InvoiceCard.Grid.Element>
        <InvoiceCard.Grid.Element title={'Outstanding:'}>
          <p>
            <CurrencyValue
              currency={accountRegionPreferences.currency}
              value={jobContent.total}
            />
          </p>
        </InvoiceCard.Grid.Element>
        <InvoiceCard.Grid.Element title={'Issued:'}>
          <p>-</p>
        </InvoiceCard.Grid.Element>
        <InvoiceCard.Grid.Element title={'Due:'}>
          <p>-</p>
        </InvoiceCard.Grid.Element>
        <InvoiceCard.Grid.Element>
          <Badge variant="soft" colour="gray">
            Draft
          </Badge>
        </InvoiceCard.Grid.Element>
      </InvoiceCard.Grid>
      {issue && <Alert colour="yellow">E-mail has bounced</Alert>}
      <Divider />
      <InvoiceCard.Actions>
        <InvoiceCard.Actions.PrimaryAction>
          <AnchorButton
            as={Link}
            variant="link-inline"
            linkColour="dark"
            to={`/projects/${protoInvoice.dealId}/invoices/quick/${protoInvoice.id}/edit`}
          >
            View details
          </AnchorButton>
        </InvoiceCard.Actions.PrimaryAction>
      </InvoiceCard.Actions>
    </InvoiceCard>
  );

  return (
    <Card sizeVariant="xs" className="bg-gray-50 typography:prose">
      <Card.Body className="space-y-1">
        <span className="ml-2">Draft</span>
        {card}
      </Card.Body>
    </Card>
  );
};

export default ProtoInvoiceCard;
